module.exports = __webpack_public_path__ + "static/pic1-0bb92d4711cd1374dda5380e54a91d3b.jpg";